<template>
  <v-app>
    <v-content>
      <v-container
        class="fill-height"
        fluid
      >
        <v-flex xs-3/>
        <v-flex xs-6>
          <v-row
            align="center"
            justify="center"
            style="width:100%"
          >
            <v-col
              cols="12"
              align="center"
              justify="center"
            >
              <v-card class="elevation-12">

                <v-toolbar
                  flat
                  color="#f1f1f1"
                >
                  <v-toolbar-title >Login</v-toolbar-title>
                  <v-spacer />
                </v-toolbar>
                <v-card-text>
                  <img :src="$store.state.config.LogoImageUrl" height="100px" >
                  <v-form>
                    <v-text-field
                      v-model ="email"
                      label="Email Address"
                      prepend-icon="mdi-email"
                      type="text"
                    />

                    <v-text-field
                      id="password"
                      v-model ="password"
                      label="Password"
                      prepend-icon="mdi-lock"
                      type="password"
                    />
                  </v-form>
                  {{ messaggio }}
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="#004C77"
                    @click="login" >Login</v-btn>

                </v-card-actions>
                <v-card-footer>
                  <div
                    v-if="loggingin"
                    class="text-xs-center">
                    <v-progress-circular
                      indeterminate
                      color="primary"
                    />
                    Logging in...
                  </div>
                  <div v-if="!loggingin"> <router-link to="/sign-up">or signup as new user</router-link></div>
                  <div v-if="!loggingin">
                    <v-btn
                      color="secondary"
                      text
                      @click="pwdreset()">or click here to recover the password
                    </v-btn>
                  </div>
                </v-card-footer>
              </v-card>

            </v-col>

          </v-row>
        </v-flex>
        {{$store.state.labels.currentlan}}
        <v-flex xs-6/>
      </v-container>
    </v-content>
  </v-app>
</template>
<script>
import firebase from 'firebase'
export default {

  data: () => ({
    email: '',
    password: '',
    source: '',
    messaggio: '',
    loggingin: false
  }),
  methods: {
    login: function () {
      const thisp = this
      thisp.messaggio = ''
      firebase.auth().signInWithEmailAndPassword(this.email, this.password)
        .then(user => {
          thisp.loggingin = true
          console.log(user)
          var credential = firebase.auth.EmailAuthProvider.credential(this.email, this.password);
            firebase.auth().currentUser.linkWithCredential(credential)
            .then(function(usercred) {
              var user = usercred.user;
              console.log("Anonymous account successfully upgraded", user);
            }).catch(function(error) {
              console.log("Error upgrading anonymous account", error);
            });

          firebase.auth().currentUser.getIdToken(/* forceRefresh */ true)
            .then(function (idToken) {
              console.log(idToken)
              //var cred = { email: thisp.email, password: thisp.password, token: idToken }
              thisp.$router.push('/utils')
              /*
              thisp.$store.dispatch('AUTH_REQUEST', cred)
                .then(() => {
                  thisp.$router.push('/')
                })
                .catch(err => {
                  thisp.loggingin = false
                  thisp.messaggio = err.message
                })
                */
            })
            .catch(err => {
              thisp.loggingin = false
              thisp.messaggio = err.message
            })
        }
        )
        .catch(err => {
          thisp.loggingin = false
          thisp.messaggio = err.message
        })

    /*
      var cred = { username: this.username, password: this.password }
      this.$store.dispatch('AUTH_REQUEST', cred)
        .then(() => {
          this.$router.push('/')
        })
        .catch(err => console.log(err))
      */
    },
    pwdreset: function () {
      this.messaggio = ''
      const thisp = this
      if (this.email) {
        firebase.auth().sendPasswordResetEmail(this.email).then(function () {
          thisp.messaggio = 'mail sent'
        }).catch(function (error) {
          thisp.messaggio = error.message
        })
      } else {
        thisp.messaggio = 'you must provide a valid mail address'
      }
    }
  }
}
</script>
